import { RouteConfig } from '../interfaces/RouteConfig';
import { MicroFrontendWrapper } from '@inform-appshell/fusion-kit-react';
import { FusionApp } from '@inform-appshell/fusion-kit-core';

export function createRouterExtension(fusionApp: FusionApp) {
  const routes: RouteConfig[] = [];
  let onChange: ((routes: RouteConfig[]) => void) | undefined;

  return {
    /**
     * Register a callback to be notified when routes change
     */
    registerRoutesChangeCallback: (callback: (routes: RouteConfig[]) => void) => {
      onChange = callback;
    },

    /**
     * Add a new MFE route dynamically
     * @param modulePath - The path to the module (e.g., "remote1/module1")
     * @param routerPath - The route path segment (e.g., "mfe1")
     */
    addMfeRoute: (modulePath: string, routerPath: string) => {
      routes.push({
        path: `/${routerPath}/*`,
        routeName: routerPath.toUpperCase(),
        element: <MicroFrontendWrapper moduleName={modulePath} fusionApp={fusionApp} />,
      });
      onChange?.([...routes]);
    },

    /**
     * Get all registered routes
     */
    getRoutes: () => [...routes],
  };
}
